exports.env = 'INT';
exports.advertiserAPIGatewayUrl = 'https://int-www.delty.com/v1/advertisers';
exports.userMgmtAPIGatewayUrl = 'https://int-www.delty.com/users';
exports.userLoginAPIGatewayUrl = 'https://int-www.delty.com/login';
exports.userLogoutAPIGatewayUrl = 'https://int-www.delty.com/logout';

exports.adminPortalUrl = 'http://int-www.delty.com/admin/#';
exports.advertiserPortalUrl = 'https://int-www.delty.com/advertiser/#';
exports.publisherPortalUrl = 'https://int-www.delty.com/publisher/#';
exports.webLoggerUrl = 'https://int-www.delty.com/v1/log';

var LogLevel = {
   none: 0,
   error: 1,
   warn: 2,
   info: 3,
   debug: 4
};
exports.frameworkLogLevel = LogLevel.warn;
exports.appLogLevel = LogLevel.debug;

exports.buttonReset = 3000;

exports.toggleFeatureGlobalExceptionHandler = true;

exports.accountManagerAdmins = [
    'spandorf@qw-corp.com',
    'tpantig@qw-corp.com',
    'kowens@qw-corp.com',
    'abroestl@qw-corp.com',
    'dzimmerman@qw-corp.com'
];
